import { safeParseJson } from "./json"

interface KwikVideoData {
	isDRM: boolean
	sources: {
		[key: string]: {
			Link: string
		}[]
	}
}

// Try to extract a playable video URL from a few common JSON shapes.
export function extractVideoUrlFromKwik(text: string | null | undefined): KwikVideoData | null {
	const obj = safeParseJson<any>(text)
	if (!obj) return null
	if (obj.Drm === "Enabled" || obj.DRMSource) {
		// console.log("DRM Enabled KWIK JSON:", obj.DRMSource)
		return {
			isDRM: true,
			sources: obj.DRMSource,
		}
	} else {
		// console.log("DRM Disabled KWIK JSON:", obj)
		return {
			isDRM: false,
			sources: obj.Source,
		}
	}
}

export function extractDurationFromKwik(text: string | null | undefined): number | null {
	const obj = safeParseJson<any>(text)
	if (!obj) return null

	return obj.DurationInSeconds
}

export function extractDRMRaramsFromKwik(text: string | null | undefined): number | null {
	const obj = safeParseJson<any>(text)
	if (!obj) return null

	return obj.DRMParameters[0]
}
